import React from 'react';
import { Outlet } from 'react-router-dom';

export const RestaurantPage: React.FC<any> = (props: any) => {
  return <Outlet {...props} />;
};
export default RestaurantPage;
